import { NavLink, useParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { Search } from '@features/common';
import { FilterMobileActions, Tabs, useMobileVisibilityFilter } from '@features/events/event-list';
import { Add, FilterIcon, IconArchive, Search as SearchIcon } from '@shared/assets/icons';
import { useWindowWidth } from '@shared/hooks';
import { useAppSelector } from '@shared/hooks/use-app-selector';
import { IconButton, PageHead } from '@shared/ui';
import { selectTab } from '@src/library/redux/events';

interface Props {
  showFilter: boolean;
  filterBtnIsActive: boolean;
  onFilterBtnClick: () => void;
  onResetFilter: () => void;
  search: string;
  onSearch: (search: string) => void;
  titles: string[];
  toggleSearch: () => void;
  isLoading: boolean;
  onArchive: () => void;
  isActiveArchive: boolean;
}

export const EventListHead = ({
  filterBtnIsActive,
  showFilter,
  onFilterBtnClick,
  onResetFilter,
  search,
  onSearch,
  titles,
  toggleSearch,
  isLoading,
  onArchive,
  isActiveArchive,
}: Props): JSX.Element => {
  const tab = useAppSelector(selectTab);
  const { code } = useParams<{ code: string }>();
  const { mobileWithFilterOn } = useMobileVisibilityFilter(showFilter);
  const windowWidth = useWindowWidth();

  return (
    <PageHead
      Left={<>{!mobileWithFilterOn && <Tabs />}</>}
      Right={
        <>
          {mobileWithFilterOn ? (
            <FilterMobileActions onReset={onResetFilter} onConfirm={onFilterBtnClick} />
          ) : (
            <>
              {windowWidth > 570 ? (
                <Search search={search} onSearch={onSearch} titles={titles} isLoading={isLoading} />
              ) : (
                <Tooltip title="Поиск" disableInteractive>
                  <IconButton variant="mobile" onClick={toggleSearch}>
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              )}

              {tab.code === 'my' && (
                <IconButton
                  onClick={onArchive}
                  variant={`${isActiveArchive ? 'activeDark' : 'dark'}`}
                >
                  <IconArchive />
                </IconButton>
              )}

              <Tooltip title="Фильтр" disableInteractive>
                <div>
                  <IconButton
                    variant={`${filterBtnIsActive ? 'activeDark' : 'dark'}`}
                    onClick={onFilterBtnClick}
                  >
                    <FilterIcon />
                  </IconButton>
                </div>
              </Tooltip>

              {tab.code === 'my' && (
                <NavLink to={`/events/${code}/create`}>
                  <Tooltip title="Создать" disableInteractive>
                    <div>
                      <IconButton variant="dark">
                        <Add />
                      </IconButton>
                    </div>
                  </Tooltip>
                </NavLink>
              )}
            </>
          )
          }
        </>
      }
    />
  );
};
